import React from 'react';

import { ReactComponent as IconChevronDown } from '@assets/icons/chevron-down.svg?comp';
import { ReactComponent as IconChevronUp } from '@assets/icons/chevron-up.svg?comp';

const FacetToggle = ({ expandFacets = true, facetBlockId, setExpandFacets }) => {
  const icon = expandFacets ? <IconChevronDown /> : <IconChevronUp />;
  const optionalProps = {};

  if (expandFacets) {
    optionalProps['aria-expanded'] = true;
    if (facetBlockId) {
      optionalProps['aria-controls'] = facetBlockId;
    }
  }
  const handleToggleFacets = () => setExpandFacets(!expandFacets);

  return (
    <div className="base-search-facets">
      <button type="button" {...optionalProps} onClick={handleToggleFacets}>
        Advanced filters {icon}
      </button>
    </div>
  );
};

export default FacetToggle;
